var validNotEmptyFilters = function (data) { return data.every(function (filter) { return (filter.type && filter.type !== "") && (filter.value && (filter.value !== "")); }); };
export default validNotEmptyFilters;
